import './BetbookPostEditorNav.less';

import clsx from 'clsx';
import React from 'react';
import i18n from '../../../common/i18n';
import { POST_ANALYSIS, POST_TICKET } from '../constants';

const BetbookPostEditorNav = ({ postType, resetPostType }) => {
    return (
        <div className="betbook-post-editor-nav flex flex-center mt-15 mb-30 fs-14">
            <button
                className={clsx('br-radius-xs br-default-light px-10 py-5 mr-8 post-option', {
                    active: postType === POST_ANALYSIS
                })}
                onClick={() => resetPostType(POST_ANALYSIS)}
            >
                {i18n('nui.betbook.post-type.analysis')}
            </button>
            <button
                className={clsx('br-radius-xs br-default-light px-10 py-5 mr-8 post-option', {
                    active: postType === POST_TICKET
                })}
                onClick={() => resetPostType(POST_TICKET)}
            >
                {i18n('nui.betbook.post-type.ticket')}
            </button>
        </div>
    );
};

export default BetbookPostEditorNav;
